// v2.0.0 — Carte commerce rendue dans le chat ou les listes de recherche.

import { toast } from "sonner";

const CATEGORY_EMOJI = {
  restaurant: "🍽️",
  boutique: "🛍️",
  pharmacie: "💊",
  service: "🔧",
  autre: "📍",
};

export default function CommerceCard({ feature }) {
  if (!feature || !feature.properties) return null;
  const p = feature.properties;
  const fid = p.id_etablissement || p.id || "x";
  const [lng, lat] = (feature.geometry && feature.geometry.coordinates) || [];
  const emoji = CATEGORY_EMOJI[p.categorie] || "📍";
  const initials = (p.nom || "?")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const openMap = () => {
    if (typeof lat === "number" && typeof lng === "number") {
      const url = `/addressing?focus=${encodeURIComponent(fid)}&lat=${lat}&lng=${lng}`;
      window.open(url, "_blank", "noopener");
    } else {
      toast.error("Coordonnées indisponibles");
    }
  };

  return (
    <div className="civ-commerce-card" data-testid={`commerce-card-${fid}`}>
      <div className="civ-commerce-head">
        {p.photo_url ? (
          <img src={p.photo_url} alt={p.nom} className="civ-commerce-photo" loading="lazy" />
        ) : (
          <div className="civ-commerce-initials" aria-hidden="true">
            {emoji} {initials}
          </div>
        )}
        <div className="civ-commerce-name-block">
          <h3 className="civ-commerce-name">{p.nom}</h3>
          <p className="civ-commerce-cat">{emoji} {p.categorie || "autre"}</p>
        </div>
      </div>
      {p.adresse_virtuelle && (
        <div className="civ-commerce-addr">
          <strong>{p.adresse_virtuelle}</strong>
        </div>
      )}
      {p.adresse_textuelle && !p.adresse_virtuelle && (
        <div className="civ-commerce-addr">{p.adresse_textuelle}</div>
      )}
      {p.commune && <div className="civ-commerce-commune">📍 {p.commune}</div>}
      {p.description_nouchi && (
        <div className="civ-commerce-desc">« {p.description_nouchi} »</div>
      )}
      {p.description && !p.description_nouchi && (
        <div className="civ-commerce-desc">{p.description}</div>
      )}
      {p.contact && <div className="civ-commerce-contact">📞 {p.contact}</div>}
      <div className="civ-commerce-actions">
        <button
          type="button"
          className="civ-commerce-map-btn"
          onClick={openMap}
          data-testid={`commerce-card-map-btn-${fid}`}
        >
          🗺 Voir sur la carte ↗
        </button>
      </div>
    </div>
  );
}
